
    module.exports = {
      render: function(){with(this){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(isModalVisible),expression:"isModalVisible"}],staticClass:"modal-overlay-container",on:{"click":close}},[_c('div',{staticClass:"modal-overlay",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"x-close-icon-alt",on:{"click":close}}),_c('section',{staticClass:"modal-content"},[_t("content")],2)])])}},
      staticRenderFns: []
    };
  